import Env from "../base/env";
import Component from "gia/Component";
import gsap from "gsap";
import { createCookieNewsletterPopupInactive } from "../utils/utils";

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;

    this.DOM.receiver = document.querySelector("c-feedback");
    this.DOM.receiver.innerHTML = this.DOM.view.innerHTML;
    this.DOM.view.parentElement.removeChild(this.DOM.view);
    this.DOM.receiver.setAttribute(
      "class",
      this.DOM.view.getAttribute("class")
    );

    Env.$html.classList.add("newsletter-registered");
    createCookieNewsletterPopupInactive();
    gsap.delayedCall(5, () => {
      this.close();
    });

    this.DOM.receiver.addEventListener("click", () => {
      this.close();
    });
  }

  close() {
    Env.$html.classList.remove("newsletter-registered");
  }
}
